import { Culture } from '../../types';

export const arapaho: Culture = {
  name: 'Arapaho',
  languageFamily: 'Algic',
  terms: [
    {
      word: 'Hohóu',
      phonetic: 'hoh-hoh',
      description: 'Arapaho greeting meaning "hello."'
    },
    {
      word: 'Heetce’nóóhobé3en',
      phonetic: 'het-seh-no-hoh-beh-en',
      description: 'Word for "thank you" in Arapaho.'
    },
    {
      word: 'Nííbe',
      phonetic: 'nee-beh',
      description: 'Arapaho term for "water."'
    },
    {
      word: 'Ceebísee',
      phonetic: 'chee-bee-seh',
      description: 'Arapaho word for "buffalo."'
    },
    {
      word: 'Wóóxuse',
      phonetic: 'woh-ksoo-seh',
      description: 'Arapaho term meaning "bear."'
    }
  ]
};